import { PoOrder } from "./po-orders";

// A PO can be for a supplier purchase or a branch to branch transfer, both are shown in the same list.
export class Po { 
    id: number;
    po_id: string;
    supplier_id: number;
    //supplier_name: string = "(Branch To Branch)"; // this will be blank for b2b transfer, but needed for list
    supplier_code: string; 
    po_number: string;
    order_date: string;// = (new Date()).toISOString().substr(0,10);
    total_qty: number; // calculated at the DB
    // Default to "Draft" status on create
    status: string = 'DRAFT';
    requesting_branch_id: number;
    requesting_branch_name: string;
    requesting_branch_code: string;
    estimated_arrival_date: string;// = (new Date()).toISOString().substr(0,10);
    actual_arrival_date: string;// = (new Date()).toISOString().substr(0,10); // This will be added from the other screens
    proforma_invoice_date: string;// = (new Date()).toISOString().substr(0,10);
    downpayment_date: string;// = (new Date()).toISOString().substr(0,10);
    final_invoice_date: string;// = (new Date()).toISOString().substr(0,10);
    payment_date: string;// = (new Date()).toISOString().substr(0,10);
    closing_date: string;// = (new Date()).toISOString().substr(0,10);
    sailing_date: string;// = (new Date()).toISOString().substr(0,10);
    transport_way: string;
    
    last_updated: string;

    items: PoOrder[];
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/pos/po.ts